import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../Reveal";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section id="about" ref={ref} data-testid="about-section" className="relative py-24 md:py-36 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-center gap-4 mb-16">
            <span className="font-serif text-2xl text-gold">01</span>
            <span className="text-[11px] uppercase tracking-[0.3em] text-stone">Meet Jennie-Marie</span>
            <span className="flex-1 h-px bg-border" />
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* image */}
          <div className="lg:col-span-6 relative">
            <motion.div
              style={{ y }}
              className="relative overflow-hidden rounded-[4px] border border-border shadow-[0_40px_100px_-40px_rgba(74,32,64,0.35)]"
            >
              <img
                src="/assets/jen-lifestyle.png"
                alt="Jennie-Marie in a calm living space"
                className="w-full h-[480px] md:h-[560px] object-cover object-[26%_32%] md:object-left"
              />
            </motion.div>
            <Reveal delay={0.15}>
              <div className="absolute -bottom-8 -right-4 md:right-8 bg-cream border border-border rounded-[4px] px-7 py-6 shadow-lg">
                <p className="font-serif text-5xl text-plum leading-none">15+</p>
                <p className="text-[11px] uppercase tracking-[0.2em] text-stone mt-2">Years guiding<br />women's wellbeing</p>
              </div>
            </Reveal>
          </div>

          {/* text */}
          <div className="lg:col-span-6 lg:pl-6 relative">
            <span className="hidden lg:block absolute left-0 top-2 bottom-2 w-px bg-border" />
            <div className="lg:pl-10">
              <Reveal>
                <h2 className="font-serif font-light text-4xl md:text-5xl leading-tight text-plum">
                  Real change begins when
                  <span className="italic text-stone"> mind, body & nourishment</span> move together.
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="mt-8 text-base md:text-lg text-stone leading-relaxed">
                  For over a decade I've walked alongside women navigating their 40s, 50s and beyond —
                  through menopause, changing bodies and the search for renewed energy. As a qualified
                  life coach, personal trainer and menopause coach, I've seen that quick fixes rarely last.
                </p>
              </Reveal>
              <Reveal delay={0.18}>
                <p className="mt-5 text-base md:text-lg text-stone leading-relaxed">
                  So I created the <span className="text-plum font-normal">MNE Formula</span> — a calm,
                  sustainable framework that blends mindset work, considered nutrition and joyful movement,
                  finished with the confidence that comes from great skin, care of Temple Spa.
                </p>
              </Reveal>
              <Reveal delay={0.26}>
                <div className="mt-10 flex items-center gap-5">
                  <img src="/assets/jennie-marie-logo.png" alt="Jennie-Marie signature" className="h-10 w-auto opacity-80" />
                  <span className="text-[11px] uppercase tracking-[0.2em] text-stone">Founder & Coach</span>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
